<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { Link } from '@shared/ui/link';
  import { Tooltip } from '@shared/ui/tooltip';
</script>

<article
  class="dark:text-dark-700 mt-5 flex flex-col-reverse gap-3 text-sm md:flex-row md:items-center md:justify-between"
>
  <Link props="{{ href: 'faq/', class: 'underline block' }}">How to purchase artwork?</Link>

  <div class="flex items-center gap-1">
    <Icon name="lock" width="{20}" height="{20}" />

    <span class="grow-0 font-medium">Secure payment with USDC</span>

    <Tooltip>
      <p class="w-[200px]">
        Purchase this asset using Stable USDC for secure, reliable transactions with no volatility.
      </p>
    </Tooltip>
  </div>
</article>
